/*********************************************************************
 * © Copyright IBM Corp. 2024
 *********************************************************************/
import React, {useLayoutEffect} from 'react'
import {DiffEditor, loader} from '@monaco-editor/react'

export const DiffViewer = ({
  before,
  after,
  language,
  options
}: {
  before: string
  after: string
  language: string
  options: any
}) => {
  useLayoutEffect(() => {
    loader.config({paths: {vs: '/svc/customer-logs-ui/monaco-editor/vs'}})
  }, [])

  return (
    <DiffEditor
      language={language}
      height={500}
      original={before}
      modified={after}
      options={{
        readOnly: true,
        enableSplitViewResizing: false,
        scrollbar: {
          alwaysConsumeMouseWheel: false
        },
        hideUnchangedRegions: {
          enabled: true
        },
        ...options
      }}
    />
  )
}
